/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import styled from "styled-components"

import { rhythm } from "../utils/typography"

function Bio() {
  const data = useStaticQuery(bioQuery)
  const { author, title } = data.site.siteMetadata

  return (
    <Container>
      <Image
        fixed={data.avatar.childImageSharp.fixed}
        alt={author}
        style={{
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          minWidth: 50,
          borderRadius: `100%`,
          border: "1px solid var(--primary)",
        }}
        imgStyle={{
          borderRadius: `50%`,
        }}
      />
      <h4 style={{ margin: 0 }}>{title}</h4>
    </Container>
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.png/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        title
      }
    }
  }
`

const Container = styled.div`
  display: flex;
  margin-bottom: 40px;
  align-items: center;
`

export default Bio
